import { useCallback, useEffect, useRef, useState } from "react";

type Pos = { x: number; y: number; zIdx: number };
type PosMap = Record<number, Pos>; // key = popup id

export const useDraggeblePopup = (ids: number[], gap = 30) => {
  const posRef = useRef<PosMap>({});
  const [, forceRender] = useState(0); // 위치 바뀔 때 강제 리렌더
  const frameRef = useRef<number | null>(null);

  /* 1. id 세트가 바뀔 때마다 초깃값 배치 */
  useEffect(() => {
    let changed = false;
    ids.forEach((id, i) => {
      if (!(id in posRef.current)) {
        posRef.current[id] = { x: i * gap, y: i * gap, zIdx: 0 };
        changed = true;
      }
    });
    if (changed) forceRender((v) => v + 1);
  }, [ids, gap]);

  /* 2. pointerDown – 팝업 div 의 onPointerDown 에 그대로 전달 */
  const pointerDown = useCallback(
    (id: number) => (e: React.PointerEvent) => {
      // 모든 팝업 초기화
      ids.forEach((id, i) => {
        posRef.current[id].zIdx = 0;
        console.log("id: ", id);
      });
      // 현재 드래그한 팝업만 zIdx = 1
      posRef.current[id].zIdx = 1;
      forceRender((v) => v + 1);

      /* 시작 좌표 */
      const sx = e.clientX;
      const sy = e.clientY;
      const { x, y } = posRef.current[id];

      /* 드래그 중 */
      const move = (ev: PointerEvent) => {
        posRef.current[id] = {
          x: x + ev.clientX - sx,
          y: y + ev.clientY - sy,
          zIdx: 1,
        };

        /* rAF 1프레임당 한 번만 그리기 */
        if (frameRef.current === null) {
          frameRef.current = requestAnimationFrame(() => {
            forceRender((v) => v + 1);
            frameRef.current = null;
          });
        }
      };

      /* 드래그 끝 */
      const up = () => {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
      };

      window.addEventListener("pointermove", move);
      window.addEventListener("pointerup", up);
    },
    [ids],
  );

  /* 3. requestAnimationFrame 누수 방지 */
  useEffect(() => {
    return () => {
      if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
    };
  }, []);

  /* 4. 호출 측에서 div style 에 바로 주입 */
  const styleOf = (id: number): React.CSSProperties => {
    const { x = 0, y = 0, zIdx = 0 } = posRef.current[id] ?? {};
    return {
      position: "absolute",
      top: 0,
      left: 0,
      transform: `translate(${x}px, ${y}px)`,
      touchAction: "none",
      cursor: "move",
      zIndex: zIdx,
    };
  };

  return { pointerDown, styleOf };
};
